import React, { useEffect, useRef, useState } from 'react'
import { AppBar, Box, Stack, Tab, Tabs, TextField, Typography } from '@mui/material'
import PropTypes from 'prop-types';
import ConfigComunicaciones from './comunicaciones/ConfigComunicaciones.jsx';
import ConfigZonas from './zonas/ConfigZonas.jsx';
import { useValue } from '../../../../context/ContextProvider';
import DatosAlarma from './DatosAlarma';
import { useAppStore } from '../../../../store/appStore.tsx';
import ConfigSms from './comunicaciones/ConfigSmsHuman.jsx';
import { getConfigAlarma, getConfigAlarmaV2 } from '../../../../actions/alarmaActions.js';
import BitControlForm from './comunicaciones/ConfigSmsIA.js';
import SmsConfigForm from './comunicaciones/ConfigSmsIA.js';
import KeyConfigForm from './claves/ConfigClaves.js';
import AcOutputConfigForm from './salidasAc/ConfigSalidasAc.js';
import SoundConfigForm from './sirena/ConfigSirena.js';
import ConfiguracionZonasForm, { generarEstadoInicialZonas } from './zonas/ConfiguracionZonasForm.jsx';
import AcOutputFormV2 from './salidasAc/ConfigSalidasAcV2.jsx';
import SalidasAcForm from './salidasAc/ConfigSalidasAcV2.jsx';
import ConfiguracionMqttForm, { generarEstadoInicialMqtt } from './comunicaciones/ConfiguracionMqttForm.jsx';
import ConfiguracionWifiForm, { generarEstadoInicialWifi } from './comunicaciones/ConfiguracionWifiForm.jsx';
import ConfiguracionGprsForm, { generarEstadoInicialGprs } from './comunicaciones/ConfiguracionGprsForm.jsx';
import ConfiguracionHttpForm, { generarEstadoInicialHttp } from './comunicaciones/ConfiguracionHttpForm.jsx';
import ConfiguracionSmsForm, { generarEstadoInicialSms } from './comunicaciones/ConfiguracionSmsForm.jsx';
import ConfiguracionAcForm, { generarEstadoInicialAc } from './salidasAc/ConfiguracionAcForm.jsx';
import ConfiguracionClavesForm, { generarEstadoInicialClaves } from './claves/ConfiguracionClavesForm.jsx';
import ConfiguracionSirenaForm, { generarEstadoInicialSirena } from './sirena/ConfiguracionSirenaForm.jsx';
import ConfiguracionRedForm, { generarEstadoInicialRed } from './comunicaciones/ConfiguracionRedForm.jsx';
import ConfiguracionAccesoForm, { generarEstadoInicialAcceso } from './acceso/ConfiguracionAccesoForm.jsx';
import ConfiguracionSelfForm, { generarEstadoInicialSelf } from './self/ConfiguracionSelfForm.jsx';



//==================================================================================================== 
// Manejo de los tabse gestión (Ingresar, Retirar, Mover)
//==================================================================================================== 
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    //console.log({value});

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ display: 'flex', p: 3, justifyContent: 'center' }}>
                    <>{children}</>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

/*
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
*/
//====================================================================================================

var estadoRxData = "init";

const GestionConfigAlarma = () => {

    //const { state: { drawerState, currentUser }, dispatch } = useValue();
    //const { state: { currentUser, datAlarma }, dispatch } = useValue();
    const { state: { datAlarma }, dispatch } = useValue();


    //---------------------------------------------------------------------------
    // Variables/funciones para la gestión de los tabs
    //---------------------------------------------------------------------------
    const [value, setValue] = React.useState(0);

    const currentUser = useAppStore(appStore => appStore.currentUser);
    const { device } = useAppStore(appStore => appStore);

    //console.log("device: ", device);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    //---------------------------------------------------------------------------

    const clavesIni = ['012345', '0101', '0202', '0303', '0404', '0505', '0606', '0707', '0808', '0909', '1010'];

    const zonaType = {
        numZona: 0,
        estadoNormal: 3,
        bypass: 0,
        habilitacion: 0,
        sensibilidad: 3,
        delaySalida: 20,
        delayEntrada: 30,
        codigoInalambrico: 2309737967,
        numZonaPanel: 0,
        descripcionCorta: '---',
        descripcionLarga: '---'
    }



    const zonasIni = [
        { numZona: 0, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: '---', descripcionLarga: '---' },
        { numZona: 1, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: '---', descripcionLarga: '---' },
        { numZona: 2, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: '---', descripcionLarga: '---' },
        { numZona: 3, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: '---', descripcionLarga: '---' },
        { numZona: 4, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: '---', descripcionLarga: '---' },
        { numZona: 5, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: '---', descripcionLarga: '---' },
        { numZona: 6, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: '---', descripcionLarga: '---' },
        { numZona: 7, estadoNormal: 3, bypass: 0, habilitacion: 0, sensibilidad: 3, delaySalida: 20, delayEntrada: 30, codigoInalambrico: 0, numZonaPanel: 0, descripcionCorta: '---', descripcionLarga: '---' },
    ]

    //const [clavesConfig, setClavesConfig] = useState({});
    //const [zonasConfig, setZonasConfig] = useState(zonasIni);

    // --- ESTADO PARA CLAVES ---
    const [clavesConfig, setClavesConfig] = useState(generarEstadoInicialClaves());
    const [clavesState, setClavesState] = useState({ selectedKeyId: 0, jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" });
    const originalClavesRef = useRef(JSON.parse(JSON.stringify(clavesConfig)));

    // --- ESTADO PARA RED ---
    const [redConfig, setRedConfig] = useState(generarEstadoInicialRed());
    const [redState, setRedState] = useState({jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" }); 
    const originalRedRef = useRef(JSON.parse(JSON.stringify(redConfig)));

    // --- ESTADO PARA WIFI ---
    const [wifiConfig, setWifiConfig] = useState(generarEstadoInicialWifi());
    const [wifiState, setWifiState] = useState({ jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" });
    const originalWifiRef = useRef(JSON.parse(JSON.stringify(wifiConfig)));

    // --- ESTADO GPRS ---
    const [gprsConfig, setGprsConfig] = useState(generarEstadoInicialGprs());
    const [gprsState, setGprsState] = useState({ jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" });
    const originalGprsRef = useRef(JSON.parse(JSON.stringify(gprsConfig)));

    // --- ESTADO PARA MQTT ---
    const [mqttConfig, setMqttConfig] = useState(generarEstadoInicialMqtt());
    const [mqttState, setMqttState] = useState({ jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" });
    const originalMqttRef = useRef(JSON.parse(JSON.stringify(mqttConfig)));

    // --- ESTADO HTTP ---
    const [httpConfig, setHttpConfig] = useState(generarEstadoInicialHttp());
    const [httpState, setHttpState] = useState({ jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" });
    const originalHttpRef = useRef(JSON.parse(JSON.stringify(httpConfig)));

    // --- ESTADO PARA SMS ---
    const [smsConfig, setSmsConfig] = useState(generarEstadoInicialSms());
    const [smsState, setSmsState] = useState({ selectedCellphone: 0, jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" });
    const originalSmsRef = useRef(JSON.parse(JSON.stringify(smsConfig)));

    // --- ESTADO PARA ZONAS ---
    const [zonasConfig, setZonasConfig] = useState(generarEstadoInicialZonas());
    const [zonasState, setZonasState] = useState({ zonaSeleccionada: 0, jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" });
    const originalZonasRef = useRef(JSON.parse(JSON.stringify(zonasConfig)));

    // --- ESTADO PARA SIRENA ---
    const [sirenaConfig, setSirenaConfig] = useState(generarEstadoInicialSirena());
    const [sirenaState, setSirenaState] = useState({ jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" });
    const originalSirenaRef = useRef(JSON.parse(JSON.stringify(sirenaConfig)));

    // --- ESTADO PARA SALIDAS AC ---
    const [acConfig, setAcConfig] = useState(generarEstadoInicialAc());
    const [acState, setAcState] = useState({ selectedOutputId: 0, jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" });
    const originalAcRef = useRef(JSON.parse(JSON.stringify(acConfig)));

    // --- ESTADO PARA CONTROL DE ACCESO ---
    const [accesoConfig, setAccesoConfig] = useState(generarEstadoInicialAcceso());
    const [accesoState, setAccesoState] = useState({ accesoSeleccionado: 0, jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" });
    const originalAccesoRef = useRef(JSON.parse(JSON.stringify(accesoConfig)));

    // --- ESTADO PARA Self Info ---
    const [selfConfig, setSelfConfig] = useState(generarEstadoInicialSelf(device));
    const [selfState, setSelfState] = useState({ selfSeleccionado: 0, jsonOutput: '', formDirty: false, jsonNeedsUpdate: true, configId: 0, estado: "Inicial", color: "black" });
    const originalSelfRef = useRef(JSON.parse(JSON.stringify(selfConfig)));

    

    //const [smsConfig, setSmsConfig] = useState({});    //errRx indica que no hubo error en la recepcion
    const [comunicacionesConfig, setComunicacionesConfig] = useState({});

    const [salidasAcConfig, setSalidasAcConfig] = useState({});
    const [salidasAcState, setSalidasAcState] = useState({});


    // Array de objetos para la iteración de actualización de la configuración recibida desde el servidor
    const configSections = [
        {
            key: 'claves',
            tabLabel: 'Claves',
            // --- Nombres de las props originales ---
            config: clavesConfig,        // antes era solo la función
            setConfig: setClavesConfig,
            state: clavesState,          // antes era solo la función
            setState: setClavesState,
            ref: originalClavesRef,
            // --- Componente a renderizar ---
            FormComponent: ConfiguracionClavesForm
        },
        {
            key: 'red',
            tabLabel: 'RED',
            config: redConfig,
            setConfig: setRedConfig,
            state: redState,
            setState: setRedState,
            ref: originalRedRef,
            FormComponent: ConfiguracionRedForm
        },
        {
            key: 'wifi',
            tabLabel: 'WiFi',
            // --- Nombres de las props originales ---
            config: wifiConfig,        // antes era solo la función
            setConfig: setWifiConfig,
            state: wifiState,          // antes era solo la función
            setState: setWifiState,
            ref: originalWifiRef,
            // --- Componente a renderizar ---
            FormComponent: ConfiguracionWifiForm
        },
        {
            key: 'gprs',
            tabLabel: 'Gprs',
            // --- Nombres de las props originales ---
            config: gprsConfig,        // antes era solo la función
            setConfig: setGprsConfig,
            state: gprsState,          // antes era solo la función
            setState: setGprsState,
            ref: originalGprsRef,
            // --- Componente a renderizar ---
            FormComponent: ConfiguracionGprsForm
        },
        {
            key: 'mqtt',
            tabLabel: 'Mqtt',
            // --- Nombres de las props originales ---
            config: mqttConfig,        // antes era solo la función
            setConfig: setMqttConfig,
            state: mqttState,          // antes era solo la función
            setState: setMqttState,
            ref: originalMqttRef,
            // --- Componente a renderizar ---
            FormComponent: ConfiguracionMqttForm
        },
        {
            key: 'http',
            tabLabel: 'Http',
            // --- Nombres de las props originales ---
            config: httpConfig,        // antes era solo la función
            setConfig: setHttpConfig,
            state: httpState,          // antes era solo la función
            setState: setHttpState,
            ref: originalHttpRef,
            // --- Componente a renderizar ---
            FormComponent: ConfiguracionHttpForm
        },
        {
            key: 'sms',
            tabLabel: 'SMS',
            config: smsConfig,
            setConfig: setSmsConfig,
            state: smsState,
            setState: setSmsState,
            ref: originalSmsRef,
            FormComponent: ConfiguracionSmsForm
        },
        {
            key: 'zonas',
            tabLabel: 'ZONAS',
            config: zonasConfig,
            setConfig: setZonasConfig,
            state: zonasState,
            setState: setZonasState,
            ref: originalZonasRef,
            FormComponent: ConfiguracionZonasForm
        },
        {
            key: 'sirena',
            tabLabel: 'SIRENA',
            config: sirenaConfig,
            setConfig: setSirenaConfig,
            state: sirenaState,
            setState: setSirenaState,
            ref: originalSirenaRef,
            FormComponent: ConfiguracionSirenaForm
        },
        {
            key: 'salAc',
            tabLabel: 'Salidas AC',
            config: acConfig,
            setConfig: setAcConfig,
            state: acState,
            setState: setAcState,
            ref: originalAcRef,
            FormComponent: ConfiguracionAcForm
        },
        {
            key: 'accesos',
            tabLabel: 'Control Acceso',
            config: accesoConfig,
            setConfig: setAccesoConfig,
            state: accesoState,
            setState: setAccesoState,
            ref: originalAccesoRef,
            FormComponent: ConfiguracionAccesoForm
        },
        {
            key: 'self',
            tabLabel: 'Self Info',
            config: selfConfig,
            setConfig: setSelfConfig,
            state: selfState,
            setState: setSelfState,
            ref: originalSelfRef,
            FormComponent: ConfiguracionSelfForm
        },
        // ... más secciones si las hubiera
    ];



    useEffect(() => {

        //console.log("Cargando datos de configuracion... [DevId: %d", device.devId);

        if (device.devId > 0) {
            const fetchData = async () => {
                //getConfigAlarmaV2 entrega como respuesta:
                //      Si bien: {success: true, message: 'Mensaje del servidor', result: {objeto con los datos solicitados}}
                //      Si mal : {success: false}
                const configAll = await getConfigAlarmaV2(currentUser, device.devId, "CMD_GET_CONFIG_ALL", dispatch);  //1100 es el comando para configurar zonas
                //console.log(configAll.success);
                try {
                    if (configAll.success === true) {
                        estadoRxData = "ok";
                        //console.log(Object.entries(configAll.result));
                        //Se crea un nuevo objeto con la configuracion jsonConfig parseada
                        const parsedConfig = Object.entries(configAll.result).reduce((acc, [key, value]) => {
                            acc[key] = {
                                device,
                                ...value,
                                jsonConfig: JSON.parse(value.jsonConfig)
                            };
                            return acc;
                        }, {});


                        /*
                        if (parsedConfig.claves.configId > 0) {
                            //console.log(parsedConfig.claves.jsonConfig);
                            setClavesConfig(parsedConfig.claves.jsonConfig);   //Solo se pasa la configuracion JSON
                            setClavesState(prev => ({ ...prev, configId: parsedConfig.claves.configId, estado: "Última config recuperada desde la base de datos.", color: "black" }));
                            originalClavesRef.current = parsedConfig.claves.jsonConfig;
                        } else {
                            setClavesState(prev => ({ ...prev, estado: "Configuración default. No se recupero desde la base de datos.", color: "warning.main" }));
                        }

                        if (parsedConfig.sms.configId > 0) {
                            //console.log(parsedConfig.sms.jsonConfig);
                            setSmsConfig(parsedConfig.sms.jsonConfig);  //Solo se pasa la configuracion JSON
                            setSmsState(prev => ({ ...prev, configId: parsedConfig.sms.configId, estado: "Última config recuperada desde la base de datos.", color: "black" }));
                            originalSmsRef.current = parsedConfig.sms.jsonConfig;
                        } else {
                            setSmsState(prev => ({ ...prev, estado: "Configuración default. No se recupero desde la base de datos.", color: "warning.main" }));
                        }

                        if (parsedConfig.zonas.configId > 0) {
                            setZonasConfig(parsedConfig.zonas);
                            setZonasConfig(parsedConfig.zonas.jsonConfig);  //Solo se pasa la configuracion JSON
                        }
                        if (parsedConfig.comunicaciones.configId > 0) {
                            setComunicacionesConfig(parsedConfig.comunicaciones);
                        }
                        */


                        // forecha para actualizar cada configuración definida en configSectios
                        configSections.forEach(section => {
                            // Accede a la configuración específica usando la clave (ej: parsedConfig['claves'])
                            const configData = parsedConfig[section.key];

                            // Comprobación de seguridad por si configData no existiera
                            if (!configData) {
                                //console.warn(`No se encontró la sección de configuración para "${section.key}"`);
                                //console.warn('Utilizando configuración default: ', section.config);
                                return; // Salta a la siguiente iteración
                            }

                            if (configData.configId > 0) {
                                // --- Caso de éxito: se encontró una configuración en la BD ---
                                //console.log(configData.jsonConfig);

                                // Llama a las funciones y actualiza la ref dinámicamente
                                section.setConfig(configData.jsonConfig);
                                section.setState(prev => ({
                                    ...prev,
                                    configId: configData.configId,
                                    estado: "Última config recuperada desde la base de datos.",
                                    color: "black"
                                }));
                                section.ref.current = configData.jsonConfig;

                            } else {
                                // --- Caso default: no hay configuración en la BD ---
                                section.setState(prev => ({
                                    ...prev,
                                    estado: "Configuración default. No se recupero desde la base de datos.",
                                    color: "warning.main"
                                }));
                            }
                        });

                    } else {
                        //console.log("No hay ninguna configuracion guardada para el dispositivo seleccionado");
                        estadoRxData = "error";
                    }
                } catch {
                    //console.log("Error recuperando la configuracion. Intentar nuevamente.");
                    estadoRxData = "error";
                }
            }

            fetchData();    //fetchData esta como una funcion porque dentro useEffect es la unica forma de hacer que la llamada sea async
        }
    }, [])

    if (device.devId === 0) {
        return (
            <Box paddingTop={3}>
                <h3>Dispositivo no seleccionado.</h3>
                <p>Seleccione un dispositivo por favor.</p>
            </Box>
        )
    }

    if (estadoRxData !== "ok") {
        return (
            <Box paddingTop={3}>
                {(estadoRxData === "error") ?
                    <>
                        <h3>Error al recibir la configuración del dispositivo</h3>
                        <p>Intente nuevamente más tarde. Gracias.</p>
                    </>
                    :
                    <>
                        <h3>Recuperando la configuracion del dispositivo...</h3>
                    </>

                }
            </Box>
        )
    }

    return (
        <Stack
            direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
            spacing={0}
            justifyContent={{ lg: 'center' }}
            flexGrow={1} pt={2} pb={2}
        >
            {/* Box en el lado izquierdo de la pantalla*/}
            <Box bgcolor='white' borderRight={1} borderColor='lightgray' flex={8} marginRight={0} padding={2} style={{ width: '100%', borderRadius: 0 }} >

                <hr />
                <Typography variant='h6' component='h1' justifyContent="center" paddingTop={1} paddingBottom={1} noWrap sx={{ flexGrow: 1, display: 'flex' }}>
                    Device Id: {device.devId} (0x{device.devId.toString(16)})
                </Typography>
                <hr /><br />

                <Box display='flex' justifyContent='center' bgcolor='white' padding={0} style={{ width: '90%', borderRadius: 0 }} >

                    <Box sx={{ maxWidth: { xs: 320, sm: 480, lg: 800 }, bgcolor: 'background.paper' }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            //orientation="vertical"
                            indicatorColor="secondary"
                            textColor="inherit"
                            //orientation="vertical"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                        >
                            {/*
                            <Tab label="Alarma" />
                            <Tab label="Claves" />
                            <Tab label="Comunicaciones" />
                            <Tab label="WiFi" />
                            <Tab label="GPRS" />
                            <Tab label="MQTT" />
                            <Tab label="HTTP" />
                            <Tab label="SMS" />
                            <Tab label="Zonas" />
                            <Tab label="Sirena" />
                            <Tab label="Salidas AC" />
                            <Tab label="Zonas Old" />
                            <Tab label="SMS Old" />
                            <Tab label="Salidas AC Old" />
                            <Tab label="Claves Old" />
                            */}

                            {configSections.map((section) => (
                                <Tab label={section.tabLabel} />
                            ))}

                        </Tabs>
                    </Box>

                </Box>

                {/*
                <CustomTabPanel value={value} index={0}>
                    <Stack direction='row' spacing={2} paddingBottom={3}>
                        <DatosAlarma
                            device={device}
                        />
                    </Stack>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={1}>
                    <Stack direction='row' spacing={2} paddingBottom={3}>
                        <ConfiguracionClavesForm
                            clavesConfig={clavesConfig} setClavesConfig={setClavesConfig}
                            clavesState={clavesState} setClavesState={setClavesState}
                            originalConfigRef={originalClavesRef}
                        />
                    </Stack>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={2}>
                    <Stack direction='row' justifyContent="center" spacing={2} paddingBottom={3} sx={{ width: '100%' }}>
                        <ConfigComunicaciones

                        />
                    </Stack>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                    <Stack direction='row' justifyContent="center" spacing={2} paddingBottom={3} sx={{ width: '100%' }}>
                        <ConfiguracionWifiForm
                            wifiConfig={wifiConfig} setWifiConfig={setWifiConfig}
                            wifiState={wifiState} setWifiState={setWifiState}
                            originalConfigRef={originalWifiRef}
                        />
                    </Stack>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={4}>
                    <Stack direction='row' justifyContent="center" spacing={2} paddingBottom={3} sx={{ width: '100%' }}>
                        <ConfiguracionGprsForm
                            gprsConfig={gprsConfig} setGprsConfig={setGprsConfig}
                            gprsState={gprsState} setGprsState={setGprsState}
                            originalConfigRef={originalGprsRef}
                        />
                    </Stack>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={5}>
                    <Stack direction='row' justifyContent="center" spacing={2} paddingBottom={3} sx={{ width: '100%' }}>
                        <ConfiguracionMqttForm
                            mqttConfig={mqttConfig}
                            setMqttConfig={setMqttConfig}
                            mqttState={mqttState}
                            setMqttState={setMqttState}
                            originalConfigRef={originalMqttRef}
                        />
                    </Stack>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={6}>
                    <Stack direction='row' justifyContent="center" spacing={2} paddingBottom={3} sx={{ width: '100%' }}>
                        <ConfiguracionHttpForm
                            httpConfig={httpConfig} setHttpConfig={setHttpConfig}
                            httpState={httpState} setHttpState={setHttpState}
                            originalConfigRef={originalHttpRef}
                        />
                    </Stack>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={7}>
                    <Stack direction='row' justifyContent="center" spacing={2} paddingBottom={3} sx={{ width: '100%' }}>
                        <ConfiguracionSmsForm
                            smsConfig={smsConfig} setSmsConfig={setSmsConfig}
                            smsState={smsState} setSmsState={setSmsState}
                            originalConfigRef={originalSmsRef}
                        />

                    </Stack>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={8}>
                    <Stack direction='row' spacing={2} paddingBottom={3} >
                        <ConfiguracionZonasForm
                            configZonas={configZonas}
                            setConfigZonas={setConfigZonas}
                            zonasState={zonasState}
                            setZonasState={setZonasState}
                            originalConfigRef={originalZonasRef} // Pasamos la referencia persistente
                            device={device}
                        />
                    </Stack>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={9}>
                    <Stack direction='row' spacing={2} paddingBottom={3} >
                        <ConfiguracionSirenaForm
                            sirenaConfig={sirenaConfig} setSirenaConfig={setSirenaConfig}
                            sirenaState={sirenaState} setSirenaState={setSirenaState}
                            originalConfigRef={originalSirenaRef}
                        />
                    </Stack>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={10}>
                    <Stack direction='row' spacing={2} paddingBottom={3} >
                        <ConfiguracionAcForm
                            acConfig={acConfig} setAcConfig={setAcConfig}
                            acState={acState} setAcState={setAcState}
                            originalConfigRef={originalAcRef}
                        />
                    </Stack>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={11}>
                    <Stack direction='row' spacing={2} paddingBottom={3} >
                        <ConfigZonas
                            zonasConfig={zonasConfig}
                            setZonasConfig={setZonasConfig}
                            device={device}
                        />
                    </Stack>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={12}>
                    <Stack direction='row' spacing={2} paddingBottom={3} >
                        <SmsConfigForm
                            initialData={smsConfig}
                            setInitialData={setSmsConfig}
                        />
                    </Stack>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={13}>
                    <Stack direction='row' spacing={2} paddingBottom={3} >
                        <AcOutputConfigForm
                        />
                    </Stack>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={14}>
                    <Stack direction='row' spacing={2} paddingBottom={3}>
                        <KeyConfigForm  //Claves
                            initialData={clavesConfig}
                            setInitialData={setClavesConfig}
                        />
                    </Stack>
                </CustomTabPanel>
                */}


                {configSections.map((section, index) => (
                    <CustomTabPanel value={value} index={index} key={section.key}>
                        <Stack direction='row' spacing={2} paddingBottom={3}>
                            {/* Renderizamos el componente dinámicamente.*/}
                            {/* Ojo! La variable debe empezar con mayúscula: FormComponent.*/}
                            <section.FormComponent
                                // Pasamos las props con los nombres genéricos y unificados
                                config={section.config}
                                setConfig={section.setConfig}
                                state={section.state}
                                setState={section.setState}
                                originalConfigRef={section.ref}
                            />
                        </Stack>
                    </CustomTabPanel>
                ))}


            </Box>

            {/* Box en el lado derecho de la pantalla*/}
            <Box bgcolor='white' flex={4} padding={2} style={{ borderRadius: 0, width: '100%' }}>
                <Typography variant="h5" component="h5" p={2} align='center'>
                    Aquí se muestra la configuración.
                </Typography>

                <Box sx={{ width: 300, p: 2, border: '1px solid lightgray', borderRadius: 1, title: "hola" }}>

                </Box>
                <Box component="fieldset" marginBottom={2} sx={{ fontSize: 13, color: "#555", borderRadius: 1, borderWidth: 1, borderColor: "#ccc", bgcolor: "#fff" }}>
                    <legend>
                        Configuración
                    </legend>
                    <h3>Hola Mundo</h3>
                    Hello World
                    <Typography variant="h5" component="h5" p={2} align='center' sx={{ color: 'black' }}>
                        Aquí se muestra la configuración.
                    </Typography>
                </Box>
            </Box>
        </Stack>
    )
}

export default GestionConfigAlarma